import { Controller } from "stimulus";

export default class extends Controller {
    connect() {
        this.recordImpression();
    }

    recordImpression() {
        const name = this.data.get("name");
        const category = this.data.get("category");
        const brand = this.data.get("brand");
        const { ga } = window;

        if (!ga) {
            console.warn(
                "Google Analytics is not loaded - Can't track product detail impression"
            );
            return;
        }

        // Requiring Enhanced Ecommerce plugin stops queue execution so we know
        // that the other commands after will execute when the tracker is ready
        ga("require", "ec", "ec.js");

        ga("ec:addProduct", { name, category, brand });

        ga("ec:setAction", "detail");

        ga("send", {
            hitType: "event",
            eventCategory: "Product",
            eventAction: "View"
        }); // Send product details
    }
}



// WEBPACK FOOTER //
// ./public/assets/scripts/controllers/product_controller.js